import { gql } from '../../../__generated__';

export const UPLOAD_FLOOR_PLANS = gql(`
  mutation UploadFloorPlanWeb($data: UploadFloorPlanWebInput) {
  uploadFloorPlanWeb(data: $data) {
    data {
      id
      name
      propertyType
      floorNumber
      assets {
        key
        width
        id
        category
        height
      }
    }
    message
  }
}
`);

export const UPDATE_FLOOR_PLAN = gql(`
  mutation UpdateFloorPlanWeb($data: UpdateFloorPlanWebInput) {
  updateFloorPlanWeb(data: $data) {
    data {
      resultScore
      address
      companyName
      id
      name
      propertyType
      floorNumber
      assets {
        angle
        key
        id
        category
        width
        height
      }
    }
    message
  }
}`);

export const GENERATE_ANNOTATION_WEB = gql(`
  mutation GenerateAnnotationWeb($input: GenerateAnnotationWebInput!) {
  generateAnnotationWeb(input: $input) {
    message
    status
  }
}`);
